import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppRoutes } from '@app';
import { AuthService } from '@services';
import { Unsubscriber } from '@shared';
import { OAuth2Service } from '../../services/auth/oAuth2.service';
import { SpinnerService } from '../../services/spinner.service';
import { RegisterPopupComponent } from './components/register-popup/register-popup.component';

interface AdvantagesItem {
  img: {
    url: string;
    alt: string;
  };
  heading: string;
  description: string;
}

const Advantages: AdvantagesItem[] = [
  {
    img: {
      url: 'assets/images/landing/icons/ic_in-out.svg',
      alt: 'Incoming and Outgoing Invoices',
    },
    heading: 'Розподіл на вхідні та вихідні посилки',
    description:
      'Відстежуйте всі відправлення, незалежно від того, де їх створено: в ' +
      'кабінеті, мобільному додатку, за адресою чи у відділенні',
  },
  {
    img: {
      url: 'assets/images/landing/icons/ic_settings.svg',
      alt: 'Extended Settings',
    },
    heading: 'Розширені налаштування',
    description:
      'Редагуйте персональні дані, знаходьте інформацію про особистого ' +
      'менеджера та підключення додаткових послуг',
  },
  {
    img: {
      url: 'assets/images/landing/icons/ic_search.svg',
      alt: 'Filtering and Search',
    },
    heading: 'Фільтрація та пошук',
    description:
      'Знаходьте й відстежуйте посилки за номером посилки та за ' +
      'допомогою інших фільтрів',
  },
  {
    img: {
      url: 'assets/images/landing/icons/ic_settings-light.svg',
      alt: 'Additional Services',
    },
    heading: 'Замовлення додаткових послуг',
    description:
      'Замовляйте й налаштовуйте будь-які додаткові послуги ' +
      'в кабінеті без допомоги персонального менеджера',
  },
  {
    img: {
      url: 'assets/images/landing/icons/ic_multiaccount.svg',
      alt: 'Contacts\' creation and search',
    },
    heading: 'Створення та пошук контактів',
    description:
      'Створюйте й шукайте контакти всередині Бізнес-кабінету за номером ' +
      'телефону та швидко заповнюйте бланк відправлення',
  },
  {
    img: {
      url: 'assets/images/landing/icons/ic_card.svg',
      alt: 'Online Payments',
    },
    heading: 'Онлайн оплата',
    description: 'Оплачуйте будь-які послуги компанії «Нова Пошта» онлайн',
  },
];

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends Unsubscriber implements OnInit {
  AppRoutes = AppRoutes;
  Advantages = Advantages;
  today = new Date();
  open = false;
  accordionObject = {
    selected: null,
    data: [
      {
        text: 'Чи потрібна повторна реєстрація в Бізнес-кабінеті?',
        content:
          'Ні, не потрібна. Для входу використовуйте персональні дані зі старого кабінету.',
      },
      {
        text: 'Чи є розподіл на Вхідні та Вихідні посилки?',
        content:
          'Так, Бізнес-кабінет розділяє документи за типами: вхідні та вихідні.',
      },
      {
        text: 'Чи можна замовляти послуги в Бізнес-кабінеті?',
        content:
          'Так, наразі доступні: Переадресація, Зміна даних та Повернення.',
      },
      {
        text: 'Чи є можливість отримати дані про особистого менеджера та підключені послуги?',
        content:
          'Так, Бізнес-кабінет має розширені налаштування, ви зможете отримати всю необхідну інформацію про особистого менеджера та підключені послуги.',
      },
    ],
  };

  constructor(
    protected oAuth2Service: OAuth2Service,
    protected spinnerService: SpinnerService,
    private authService: AuthService,
    private router: Router,
    private meta: Meta,
    private dialog: MatDialog,
  ) {
    super();
    this.meta.addTag({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    });
  }

  accordion(item): void {
    this.accordionObject.selected =
      this.accordionObject.selected !== item ? item : null;
  }

  ngOnInit(): void {
    this.spinnerService.stop();
    if (this.authService.user) {
      this.router.navigate([AppRoutes.dashboard]);
    }
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      } as ScrollOptions);
    }, 500);
  }

  registerNewAccount(): void {
    this.subscriptions = this.dialog.open(RegisterPopupComponent, {
      autoFocus: false,
    })
      .componentInstance
      .registerNewAccount
      .subscribe(() => this.oAuth2Service.login(null, true).then());
  }
}
